if (!customElements.get('b2b-product-pricing')) {
  class B2bProductPricing extends HTMLElement {
    constructor() {
      super();
      this.tiers = [
        { id: 'tier_10_29', minQty: 10 },
        { id: 'tier_30_99', minQty: 30 },
        { id: 'tier_100_249', minQty: 100 },
        { id: 'tier_250_499', minQty: 250 },
        { id: 'tier_500_999', minQty: 500 },
        { id: 'tier_1000_plus', minQty: 1000 }
      ];
    }

    connectedCallback() {
      this.select = this.querySelector('[data-b2b-tier-select]');
      this.statusEl = this.querySelector('[data-b2b-tier-status]');
      this.cards = this.querySelectorAll('[data-b2b-product-card]');
      this.tierStatusTemplate = this.dataset.tierStatusTemplate || 'Showing prices for [tier]';
      this.cardPriceTemplate = this.dataset.cardPriceTemplate || 'Starting [price]/pcs';
      this.cardQtyTemplate = this.dataset.cardQtyTemplate || 'at [qty] pcs';

      if (!this.select) return;

      this.select.addEventListener('change', () => this.updatePrices());
      this.updatePrices();
      this.initCatalogueScroll();
    }

    initCatalogueScroll() {
      const scrollBtn = this.querySelector('[data-b2b-catalogue-scroll]');
      if (!scrollBtn) return;

      scrollBtn.addEventListener('click', (event) => {
        event.preventDefault();

        const targetId = scrollBtn.dataset.scrollTarget;
        if (!targetId) return;

        const target = document.getElementById(targetId);
        if (!target) return;

        const isDesktop = window.matchMedia('(min-width: 768px)').matches;
        const useOffset = scrollBtn.dataset.scrollUseOffset === 'true';
        let offset = 0;

        if (useOffset) {
          offset =
            parseInt(
              isDesktop ? scrollBtn.dataset.scrollOffsetDesktop : scrollBtn.dataset.scrollOffsetMobile,
              10
            ) || 0;
        }

        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    }

    getSelectedTier() {
      const option = this.select.options[this.select.selectedIndex];
      const tierId = this.select.value;
      const matched = this.tiers.find((tier) => tier.id === tierId);
      const minQty = parseInt(option?.dataset.minQty, 10);

      return {
        id: tierId || matched?.id || this.tiers[0].id,
        minQty: Number.isNaN(minQty) ? matched?.minQty || this.tiers[0].minQty : minQty
      };
    }

    getTierStatusText() {
      const tierText = this.select.options[this.select.selectedIndex]?.text || '';
      // Dropdown keeps "From …"; status text should not repeat "from"
      const tierLabel = tierText.replace(/^\s*from\s+/i, '').toLowerCase();
      return this.tierStatusTemplate.replace('[tier]', tierLabel);
    }

    formatPrice(value) {
      const amount = parseFloat(String(value).replace(',', '.'));
      if (Number.isNaN(amount)) return value;
      return `€${amount.toFixed(2).replace('.', ',')}`;
    }

    formatCardPriceHtml(template, formattedPrice) {
      if (!template.includes('[price]')) return template;

      const [before, after] = template.split('[price]');
      return `${before}<strong>${formattedPrice}${after}</strong>`;
    }

    formatCardQtyText(template, minQty) {
      return template.replace('[qty]', minQty);
    }

    updatePrices() {
      const tier = this.getSelectedTier();

      if (this.statusEl) {
        this.statusEl.textContent = this.getTierStatusText();
      }

      this.cards.forEach((card) => {
        const price = card.getAttribute(`data-${tier.id.replace(/_/g, '-')}`);
        const priceEl = card.querySelector('[data-b2b-card-price]');
        const qtyEl = card.querySelector('[data-b2b-qty]');

        if (priceEl && price) {
          priceEl.innerHTML = this.formatCardPriceHtml(this.cardPriceTemplate, this.formatPrice(price));
        }

        if (qtyEl) {
          qtyEl.textContent = this.formatCardQtyText(this.cardQtyTemplate, tier.minQty);
        }
      });
    }
  }

  customElements.define('b2b-product-pricing', B2bProductPricing);
}
